import { render, staticRenderFns } from "./ContactRequestListView.vue?vue&type=template&id=444ec241&scoped=true"
import script from "./ContactRequestListView.vue?vue&type=script&lang=ts"
export * from "./ContactRequestListView.vue?vue&type=script&lang=ts"
import style0 from "./ContactRequestListView.vue?vue&type=style&index=0&id=444ec241&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444ec241",
  null
  
)

export default component.exports